var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftSentinel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.1694C22 17.673 14.1429 22.7629 12.4286 23.894C12.2857 24.0353 12 24.0353 11.7143 23.894C10 22.9043 2 17.673 2 11.1694V3.39323C2 3.11046 2.28571 2.82769 2.57143 2.82769C8.71429 2.6863 7.42857 0 12 0C16.5714 0 15.1429 2.6863 21.2857 2.82769C21.5714 2.82769 21.8571 3.11046 21.8571 3.39323L22 11.1694Z",
    fill: "#1B93EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11.0457C21.5 17.1132 14.1289 22.0249 12.5391 22.8917C12.3945 23.0361 12.1055 23.0361 11.9609 22.8917C10.3711 21.8804 3 16.9687 3 11.0457V3.82263C3 3.53371 3.14453 3.24478 3.43359 3.10032C9.07031 2.95586 7.76953 0.5 12.1055 0.5C16.4414 0.5 15.1406 3.10032 20.7773 3.10032C21.0664 3.10032 21.3555 3.38925 21.3555 3.67817L21.5 11.0457Z",
    fill: "url(#paint0_linear_5555_319175)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0714 8.4182C14.0714 8.4182 15.7857 9.96647 16.0714 11.937C16.0714 12.2185 16.5 12.5 16.7857 12.5H18.7857C19.2143 12.5 19.5 12.2185 19.5 11.7962C19.5 11.7962 19.5 11.7962 19.5 11.6555C19.0714 7.57369 15.3571 4.6179 11.2143 5.04015C7.64286 5.46241 4.92857 8.13669 4.5 11.6555C4.5 12.0777 4.78571 12.3592 5.07143 12.3592C5.07143 12.3592 5.07143 12.3592 5.21429 12.3592H7.21429C7.5 12.3592 7.78571 12.0777 7.92857 11.7962C8.35714 9.82572 10.0714 8.4182 12.0714 8.4182Z",
    fill: "#C3F1FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5C13.6569 15.5 15 14.1569 15 12.5C15 10.8431 13.6569 9.5 12 9.5C10.3431 9.5 9 10.8431 9 12.5C9 14.1569 10.3431 15.5 12 15.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5555_319175",
    x1: 12.2688,
    y1: 22.2213,
    x2: 12.2688,
    y2: -0.30032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B93EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2095EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2E9CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#45A7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#64B6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BB9F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftSentinel);
export default __webpack_public_path__ + "static/media/Microsoft_Sentinel.a7e06929570508291e5756a8c1fa4bff.svg";
export { ForwardRef as ReactComponent };